/**
 * index.ts - Configgr - Configuration and Preferences Management
 * 
 * CHANGE HISTORY:
 * - 251023_1854 [pending] danielbeer: Add standard modules and complete exports
 * - 251023_1840 [pending] danielbeer: Add ConfiggrManager core and Actr integration
 * - 251021_0421 [7529d5e] danielbeer: feat: migrate all packages to TypeScript structure
 */

// Core
export { ConfiggrManager, getConfiggr } from './core/ConfiggrManager';

// React Components (should be imported via @opcentral/dependr)
export { PackageInfoPanel, ViewSettingsPanel, PreferencesModal } from './components';
export type { PackageInfo, PackageInfoPanelProps, PreferencesModule, PreferencesModalProps } from './components';

// Standard Modules
export * from './modules';

// Re-export for convenience
import { ConfiggrManager } from './core/ConfiggrManager';
export type { ConfiggrManagerOptions } from './core/ConfiggrManager';

// Hooks
export { useConfiggr, initializeConfiggr, getConfiggrManager } from './hooks/useConfiggr';
export type { UseConfiggrOptions, UseConfiggrReturn } from './hooks/useConfiggr';

export default {
  ConfiggrManager
};
